function setCookie(c_name, value, exdays) {
    
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let c_value =encodeURI(value) + ((exdays == null || exdays == '' || exdays == 0) ? "" : "; expires=" + exdate.toUTCString());
    
    document.cookie = c_name + "=" + c_value;
}

function getCookie(c_name) {
    let i, x, y, ARRcookies = document.cookie.split(";");
    
    let result = false;
    
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x === c_name) {
            result = decodeURI(y);
        }
    }
    
    return result;
}

export default {setCookie, getCookie};


// WEBPACK FOOTER //
// ../components/core/helperFunctions/Cookie.js